import React, {
  Suspense,
  useCallback,
  useEffect,
  useLayoutEffect,
  useState,
} from 'react';
import EngineeringPageLoading from './EngineeringPageLoading';
import styles from './EngineeringPageTransition.module.css';

function ReadyPage({ onReady, children }) {
  useLayoutEffect(onReady, [onReady]);
  return children;
}

export default function EngineeringPageTransition({ children }) {
  const [ready, setReady] = useState(false);
  const [showLoading, setShowLoading] = useState(true);
  const onReady = useCallback(() => setReady(true), []);

  useEffect(() => {
    if (!ready) return undefined;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      setShowLoading(false);
      return undefined;
    }
    // Also clean up if transitionend is suppressed by the browser.
    const timer = window.setTimeout(() => setShowLoading(false), 360);
    return () => window.clearTimeout(timer);
  }, [ready]);

  return (
    <>
      <div className={`${styles.content} ${ready ? styles.ready : ''}`}>
        <Suspense fallback={null}>
          <ReadyPage onReady={onReady}>{children}</ReadyPage>
        </Suspense>
      </div>
      {showLoading && (
        <div
          className={`${styles.loading} ${ready ? styles.leaving : ''}`}
          aria-hidden={ready ? 'true' : undefined}
          onTransitionEnd={event => {
            if (
              ready &&
              event.target === event.currentTarget &&
              event.propertyName === 'opacity'
            ) {
              setShowLoading(false);
            }
          }}
        >
          <EngineeringPageLoading />
        </div>
      )}
    </>
  );
}
